import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { login } from '@/auth/oidc'
import { LanguageMenu } from '@/components/AppShell'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader } from '@/components/ui/card'

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    returnTo: z.string().optional().catch(undefined),
    loggedOut: z.coerce.number().optional().catch(undefined),
    expired: z.coerce.number().optional().catch(undefined),
  }),
  component: LoginPage,
})

function LoginPage() {
  const { t } = useTranslation()
  const { returnTo, loggedOut, expired } = Route.useSearch()
  const [failed, setFailed] = useState(false)

  async function handleLogin() {
    setFailed(false)
    try {
      // Nur relative Ziele zulassen (kein Open Redirect über returnTo)
      await login(returnTo?.startsWith('/') && !returnTo.startsWith('//') ? returnTo : '/')
    } catch {
      setFailed(true)
    }
  }

  return (
    <main id="main-content" className="flex min-h-screen items-center justify-center p-6">
      <div className="absolute top-4 right-4">
        <LanguageMenu />
      </div>
      <Card className="w-full max-w-md">
        <CardHeader>
          <h1 className="text-2xl leading-none font-semibold">{t('login.title')}</h1>
          <CardDescription>{t('login.intro')}</CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4">
          {loggedOut ? (
            <Alert>
              <AlertDescription>{t('login.loggedOut')}</AlertDescription>
            </Alert>
          ) : null}
          {expired ? (
            <Alert>
              <AlertDescription>{t('login.expired')}</AlertDescription>
            </Alert>
          ) : null}
          {failed && (
            <Alert variant="destructive">
              <AlertDescription>{t('login.error')}</AlertDescription>
            </Alert>
          )}
          <Button size="lg" onClick={() => void handleLogin()}>
            {t('login.button')}
          </Button>
        </CardContent>
      </Card>
    </main>
  )
}
